export default __webpack_public_path__ + "static/media/1650.eae6b531.png";